import { styled } from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledCartSummary = styled.div`
  .cart-summary {
    width: 388px;
    margin-bottom: 30px;

    .requires-auth {
      display: flex;
      justify-content: center;
      padding: 15px;
      border: 1px solid;
      border-radius: 5px;
      margin-bottom: 10px;
      color: ${(props) => props.theme.black};
      background-color: ${(props) => props.theme.warning};
      border-color: ${(props) => props.theme.warning};
    }

    .cart-summary-title {
      font-size: 24px;
      font-weight: 400;
      padding-bottom: 15px;
      padding-top: 15px;
    }

    .cart-order-summary-wrapper {
      background-color: ${(props) => props.theme.summaryBackground};
      width: 100%;
      padding: 20px;
      border: solid 1px ${(props) => props.theme.lightborder};
      border-radius: 5px;
      font-family: ${(props) => props.theme.fontText};

      .cart-name {
        font-size: 24px;
      }

      .ant-btn-text {
        padding: 3px 0;

        span {
          text-decoration: underline;
        }
      }

      .cart-order-summary-save-cart {
        margin-bottom: 32px;

        .cart-order-summary-save-cart-input {
          display: flex;
          align-items: center;
          gap: 4px;

          .ant-input {
            height: 40px;
            background-color: ${(props) => props.theme.white};
          }

          .ant-btn {
            height: 40px;
            border-radius: 4px;
          }
        }
      }

      .cart-order-summary-collection {
        .cart-farm-order-summary {
          font-size: 16px;
          margin-bottom: 30px;

          &.mobile-total {
            display: none;
          }

          .farm-title {
            font-weight: 600;
          }

          .farm-summary-wrapper {
            .cart-summary-container {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;

              .cart-summary-item {
                margin: 4px 0 0 0;
                font-weight: 400;
              }
            }
          }
        }
      }

      .cart-farm-order-summary.total {
        margin-bottom: 30px;
        padding: 30px 0;
        border-top: 1px solid ${(props) => props.theme.borderBottom};
        border-bottom: 1px solid ${(props) => props.theme.borderBottom};

        .farm-summary-wrapper {
          .cart-summary-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .cart-summary-item {
              margin: 4px 0 0 0;
              font-weight: 400;
            }

            .cart-summary-item.price {
              font-weight: 700;
            }
          }
        }
      }

      .cart-farm-order-summary.coupon {
        margin-bottom: 6px;

        label {
          font-family: ${(props) => props.theme.fontText};
          font-size: 16px;
        }

        .coupon-btn {
          color: #9e9e1b;
          border-color: #9e9e1b;
          background: transparent;
          font-weight: 700;
          width: 30%;
          height: 48px;
          font-family: ${(props) => props.theme.fontText};

          &:hover {
            color: #fff;
            background: #9e9e1b;
          }
        }

        .applied-coupon {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;

          > div {
            width: 60%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .applied-coupon-small {
              font-size: 12px;
            }
          }
        }

        > .ant-form-item {
          margin-bottom: 0;
        }

        .ant-form-item-control-input-content {
          display: flex;
          justify-content: space-between;

          .ant-form-item {
            width: 60%;
          }
        }
      }

      .cart-summary-submit-wrapper {
        .cart-summary-final-price {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          font-family: ${(props) => props.theme.fontText};
          font-size: 16px;
        }

        .rules {
          display: flex;
          flex-direction: column;
          padding-top: 30px;
          border-top: 1px solid ${(props) => props.theme.borderBottom};

          @media only screen and (max-width: ${breakpoints.sm}px) {
            border-top: 1px solid ${(props) => props.theme.lightGrayishBlue};
          }

          .ant-form-item {
            display: flex;
            align-items: center;
            margin: 0;
          }

          .cart-summary-final-price-title {
            font-weight: 400;
          }

          .cart-summary-price {
            font-weight: 700;
          }
        }

        .cart-summary-submit-btn {
          font-weight: 700;
          width: 100%;
          height: 52px;
          font-family: ${(props) => props.theme.fontText};
        }

        .cart-summary-submit-btn-view {
          width: 100%;
          height: 52px;
          font-family: ${(props) => props.theme.fontText};
        }

        .cart-summary-submit-btn-view {
          border: solid 1px ${(props) => props.theme.brand02};
          background: transparent;
          color: ${(props) => props.theme.black};
        }

        .cart-summary-submit-btn-view.order-again {
          margin-bottom: 10px;
        }
      }

      .cart-summary-final-price-title-wrap {
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;

        .cart-summary-price {
          font-weight: 600;
        }

        &:not(.view) {
          padding-bottom: 30px;
          border-bottom: 1px solid ${(props) => props.theme.borderBottom};

          @media only screen and (max-width: ${breakpoints.sm}px) {
            border-bottom: 1px solid ${(props) => props.theme.lightGrayishBlue};
          }
        }

        @media only screen and (max-width: ${breakpoints.sm}px) {
          margin-top: 30px;
          display: none;
        }
      }
    }
  }

  .total-summary {
    display: none;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-form {
      display: flex;
      justify-content: center;

      .cart-summary {
        width: 100%;
        max-width: 100%;

        .cart-order-summary-wrapper {
          background-color: transparent;
          border: none;
          border-radius: 15px;

          .cart-summary-final-price-title-wrap {
            font-size: 1rem;

            .cart-summary-price {
              font-size: 1rem;
            }
          }

          .cart-order-summary-collection {
            border-bottom: 1px solid ${(props) => props.theme.borderBottom};
          }
        }

        .cart-farm-order-summary.coupon {
          label {
            font-size: 1rem;
          }
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .cart-summary {
      .cart-summary-title {
        font-size: 1.125rem;
        font-weight: 600;
        padding: 30px 0;
      }

      .cart-farm-order-summary {
        .farm-title {
          font-size: 1rem;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .cart-summary {
      .cart-order-summary-wrapper {
        padding: 20px;
        background-color: ${(props) => props.theme.white} !important;

        .cart-order-summary-collection {
          border-bottom: 1px solid ${(props) => props.theme.lightGrayishBlue};
        }

        .cart-farm-order-summary {
          margin-bottom: 20px;

          &.total {
            display: none;
          }

          &.mobile-total {
            display: block;
            padding-bottom: 23px;
            border-bottom: 1px solid ${(props) => props.theme.lightGrayishBlue};

            .farm-summary-wrapper {
              margin-top: 23px;

              .cart-summary-container {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding: 13px 0 13px 0;
                padding: 7px 0;
                border-bottom: 1px solid
                  ${(props) => props.theme.lightGrayBorder};

                &:last-child {
                  border-bottom: 0;
                }

                .cart-summary-item {
                  margin: 0;
                }

                .cart-summary-item.price {
                  color: ${(props) => props.theme.colorText};
                  font-weight: 600 !important;
                  margin: 0;
                }
              }
            }
          }
        }

        .cart-summary-submit-wrapper {
          .cart-summary-submit-btn {
            display: none;
          }
        }
      }

      .cart-summary-submit-btn-view {
        padding: 0;
        background-color: ${(props) => props.theme.white};
      }
    }

    .total-summary {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0 20px;
      padding: 31px 20px 61px 20px;
      background-color: ${(props) => props.theme.brand01};
      border-radius: 15px;
      position: fixed;
      width: 100vw;
      bottom: 70px;
      left: 0;
      z-index: 10;

      .total-summary-text {
        color: ${(props) => props.theme.white};
        font-weight: 400;
        display: flex;
        gap: 20px;
        align-items: center;

        b {
          white-space: nowrap;
        }
      }

      button {
        height: auto;
        padding: 8px 16px;
      }

      .cart-summary-submit-btn-view,
      .cart-summary-submit-btn {
        display: none;
      }
    }
  }
`;
